import { dirOf } from './locales';
import type { LocaleCode } from './types';

/**
 * Sync <html dir> + <html lang> from a locale. Web-only. No-op outside a browser.
 */
export function syncHtmlDir(locale: LocaleCode): void {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const doc = (globalThis as any).document as
    | { documentElement: { lang: string; dir: string } }
    | undefined;
  if (!doc) return;
  doc.documentElement.lang = locale;
  doc.documentElement.dir = dirOf(locale);
}
